module.exports = __webpack_public_path__ + "img/logo-probus.922c0fb1.png";